/**
 * @module helper
 */
import { appendLeft } from './appendLeft';

/**
 * will remove T and Z
 * 
 * eg. timezone: +08:00   getISOString(newDate('2019-04-25T13:00:00Z')) === '2019-04-25 21:00:00'
 */
export function getISOString(date?: Date): string {
	if (!date) {
		return '';
	}

	const year = date.getFullYear();
	const month = appendLeft(date.getMonth() + 1, 2);
	const day = appendLeft(date.getDate(), 2);
	const hour = appendLeft(date.getHours(), 2);
	const minutes = appendLeft(date.getMinutes(), 2);
	const seconds = appendLeft(date.getSeconds(), 2);

	return `${year}-${month}-${day} ${hour}:${minutes}:${seconds}`;
}
